<div class="form-group">
  @if (label) {
    <label class="fw-bold">{{ label }}</label>
  }
  <div class="form-floating">
    <textarea
      #textAreaField
      [formControl]="textareaFormControl"
      [class.is-invalid]="textareaFormControl && textareaFormControl.invalid && (textareaFormControl.touched || textareaFormControl.dirty)"
      [class.is-valid]="textareaFormControl && textareaFormControl.valid && (textareaFormControl.touched || textareaFormControl.dirty)"
      [readonly]="readonly"
      [style]="'height: ' + height + 'px; min-height: ' + height + 'px;'"
      class="form-control"
      [placeholder]="placeholder">
    </textarea>
    @if (textareaFormControl && textareaFormControl.invalid && (textareaFormControl.touched || textareaFormControl.dirty)) {
      <div class="invalid-feedback">
        @if (textareaFormControl.errors?.['required']) {
          <span>Required field</span>
        }
        @if (textareaFormControl.errors?.['minlength']) {
          <span>At least 3 characters required.</span>
        }
        @if (textareaFormControl.errors?.['backendError']) {
          <span>
            {{ textareaFormControl.errors?.['backendError'] }}
          </span>
        }
      </div>
    }
  </div>
</div>